import { useFetchHotelShop } from "../../../hooks";
import type { ShopPageRouteProps } from "../types";

export const useShopPageFetch = (props: ShopPageRouteProps) => {
  useFetchHotelShop(props);
};
